import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import {HttpStatus, Status} from "../../common/Constants";
import MasterLocatorModifying from "./components/MasterLocatorModifying";
import MasterLocatorFilter from "./components/MasterLocatorFilter";
import {formGroupLocator} from "./config";
import Api from "../../../Services/Api";
import ToggleButton from "react-toggle-button";
import {flattenFormGroupObject, getValueFromDDL, removeNullFields} from "../../common/mapper";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../Services/Utils";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class MasterLocator extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "kodeLocation",
            label: "Kode Lokasi",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "kodeCabang",
            label: "Kode Cabang",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nameLocation",
            label: "Nama Lokasi",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => {
                    return (
                        <FlexView vAlignContent="center">
                            {this.props.menuAccess && this.props.menuAccess.updateAccess && (
                                <SimpleButton
                                    category="action_button"
                                    style={{marginRight: 15, backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}
                                    onClick={() => this.handleModifyingModalVisibility(tableMeta.rowIndex)}
                                />
                            )}
                            {this.props.menuAccess && this.props.menuAccess.updateAccess && (
                                <ToggleButton
                                    value={R.equals(this.state.dataTable[tableMeta.rowIndex].status, "ACTIVE")}
                                    onToggle={(value) => this.handleChangeStatus(tableMeta.rowIndex, !value)}
                                />
                            )}
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.initialData = {
            kodeLocation: null,
            kodeCabang: null,
            nameLocation: null,
            status: Status.INACTIVE,
        };
        this.initialSearch = {
            kodeLokasi: null,
        };
        this.state = {
            loading: false,
            filterVisible: false,
            modifyingVisible: false,
            selectedData: null,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataLocator();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: !R.isNil(index) ? {...prevValue.dataTable[index]} : null,
            modifyingVisible: !prevValue.modifyingVisible,
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.handleClearSearch();
        let req = {
            paramFilters: removeNullFields(this.parseFilterData(this.state.filterData)),
            limit: this.state.pagination.limit,
            page: 1
        };
        this.handleChangeSubmittedFilterData(req.paramFilters);
        this.handleModalFilterVisibility();
        await this.fetchDataLocator(req);
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            kodeCabang: getValueFromDDL(formGroup, "kodeCabang"),
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveMasterLocation,
            menuName: "Master Locator",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            this.handleModifyingModalVisibility();
            const {submittedFilterData,pagination} = this.state;
            await this.fetchDataLocator({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        this.handleClearFilter();
        let req = {
            paramFilters: removeNullFields(this.state.search),
            limit: this.state.pagination.limit,
            page: 1,
        }
        this.handleChangeSubmittedFilterData(req.paramFilters);
        await this.fetchDataLocator(req);
        this.handleTriggerLoading();
    }

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";

        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").saveMasterLocation,
            data,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            const {submittedFilterData,pagination} = this.state;
            await this.fetchDataLocator({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({...prevValue, filterData: this.initialData}));
    };

    handleClearSearch = () => {
        this.setState((prevValue) => ({...prevValue, search: this.initialSearch}));
    };

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));
        let {submittedFilterData} = this.state;
        await this.fetchDataLocator({
            paramFilters: submittedFilterData, page: page, limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: 1,
                limit: limit,
            }
        }));
        let {submittedFilterData} = this.state;
        await this.fetchDataLocator({
            paramFilters: submittedFilterData, page: 1, limit: limit
        });
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataLocator = async (body) => {
        this.setState((prevState) => ({...prevState, pagination: {...prevState.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0 ?
            body :
            {paramFilters: {}, page: 1, limit: 5};
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam,
            req,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    count: res.data.totalData,
                    limit: req.limit,
                    page: req.page,
                }
            }));
        }
    }

    parseFilterData(data) {
        return {
            ...data,
            kodeLocation: getValueFromDDL(data, "kodeLocation"),
            kodeCabang: getValueFromDDL(data, "kodeCabang"),
            status: getValueFromDDL(data, "status")
        };
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Locator",
            setError: this.props.setError,
            args: args,
        })
    };

    handleChangeSubmittedFilterData = (data) => {
        this.setState((prevState) => ({
            ...prevState,
            submittedFilterData: data,
        }));
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{justifyContent: "space-between"}} className="margin-bottom-5px margin-top-5px">
                        <FlexView vAlignContent="center" className="margin-bottom-5px">
                            <SimpleInput
                                type="text"
                                name="kodeLocation"
                                placeholder="Kode Lokasi"
                                containerclassname="margin-bottom-none"
                                onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                                value={this.state.search.kodeLocation}
                            />
                            <SimpleButton onClick={this.handleSubmitSearch}
                                          className="margin-top-5px">Cari</SimpleButton>
                        </FlexView>
                        <SimpleButton
                            onClick={this.handleModalFilterVisibility}
                            styles={{width: "unset", marginTop: "5px"}}
                            icon={<i className={"fa fa-qrcode"}></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.count}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(
                            (tableState) => this.handleChangePage(tableState),
                            (tableState) => this.handleChangeRowsPerPage(tableState),
                        )}
                        footerAdditionalButtons={
                            <>
                                {
                                    this.props.menuAccess && this.props.menuAccess.createAccess && (
                                        <SimpleButton
                                            onClick={() => this.handleModifyingModalVisibility()}
                                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                                            text={"Tambah"}
                                        />
                                    )
                                }
                            </>
                        }
                    />
                </Container>

                {this.state.modifyingVisible && (
                    <MasterLocatorModifying
                        formGroup={formGroupLocator}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingModalVisibility}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}

                {this.state.filterVisible && (
                    <MasterLocatorFilter
                        selectedData={this.state.filterData}
                        visible={this.state.filterVisible}
                        onClickClose={this.handleModalFilterVisibility}
                        onClearFilter={this.handleClearFilter}
                        onValueChange={this.handleValueChange}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterLocator);